import { View } from "react-native";
import { useTranslation } from "react-i18next";

import { IconButton } from "../../primitives/IconButton";
import { TextField } from "../../primitives/TextField";
import type { UiTheme } from "../../theme";

export type PrescribeNoteEditorProps = {
  theme: UiTheme;
  value: string;
  onChange: (text: string) => void;
  placeholder: string;
  /** Review fix (PE-22 K3 triad, Minor a11y): the editor used to dismiss
   *  ONLY by re-tapping the "Nota" chip that opened it — not self-evident
   *  once focus has moved inside the field. Calls the SAME close handler
   *  the chip toggle uses (FocusPanel's noteEditorOpen), so there is exactly
   *  one way this editor closes, reached from two affordances. */
  onClose: () => void;
};

// PE-22 K3.4 — the "Nota" chip's editor. No existing inline text-edit
// primitive fit this job (SetCountRow's disclosure is a stepper, not text;
// NoteComposer is a chat-style send into the timeline feed, a different
// write path entirely) — a minimal token-only TextField row, writing live on
// every keystroke like every other prescribe field (no Send button, no
// second commit gesture).
export function PrescribeNoteEditor({
  theme,
  value,
  onChange,
  placeholder,
  onClose,
}: PrescribeNoteEditorProps) {
  const { t } = useTranslation();
  return (
    <View
      style={{
        marginTop: theme.spacing.s2,
        flexDirection: "row",
        alignItems: "flex-start",
        gap: theme.spacing.s2,
      }}
    >
      <TextField
        theme={theme}
        multiline
        minRows={2}
        value={value}
        onChangeText={onChange}
        placeholder={placeholder}
        accessibilityLabel={placeholder}
        style={{ flex: 1 }}
      />
      <IconButton
        theme={theme}
        name="close"
        variant="cancel"
        accessibilityLabel={t("mobile.logger.noteClose", {
          defaultValue: "Done",
        })}
        onPress={onClose}
      />
    </View>
  );
}
